import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { toast } from "react-toastify";
import { Heading, Loader, Popup, ToastErrorTile } from "uikit/components";
import { useGenerateMunicipalitySummary } from "hooks/municipalitySummary";
import styles from "./MunicipalitySummaryPage.module.styl";
import MunicipalitySummaryView from "components/municipalitySummary/MunicipalitySummaryView/MunicipalitySummaryView";
import { Helmet } from "react-helmet-async";

export default function MunicipalitySummaryPage() {
    const { municipalityId } = useParams();

    const [result, setResult] = useState(null);
    const [showPlaceHolder, setShowPlaceHolder] = useState(false);

    const { build: generateMunicipalitySummary, isLoading: isGeneratingMunicipalitySummary } =
        useGenerateMunicipalitySummary({
            onSuccess: (data) => setResult(data),
            onError: (error) => {
                const data = error.response.data;
                if (data.status === 422) setShowPlaceHolder(true);
                else toast.error(<ToastErrorTile error={error} />);
            },
        });

    useEffect(() => {
        generateMunicipalitySummary(municipalityId);
    }, [generateMunicipalitySummary, municipalityId]);

    if (isGeneratingMunicipalitySummary) {
        return (
            <>
                <Helmet>
                    <title>Панель управления отраслью спорта</title>
                </Helmet>
                <Popup blockClickOnOverlay appearance="adaptive">
                    <Loader position={"margin-auto"} text={"Подождите. Данные загружаются."} testName="loader-text" />
                </Popup>
            </>
        );
    }

    if (showPlaceHolder) {
        return (
            <>
                <Helmet>
                    <title>Панель управления отраслью спорта</title>
                </Helmet>
                <Heading size={"h1"} className={styles.placeHolder} name="data-is-not-ready-header">
                    В настоящий момент данные для дашборда ещё не сформированы. Повторите запрос
                    завтра.
                </Heading>
            </>
        );
    }

    if (result != null) {
        return (
            <>
                <Helmet>
                    <title data-test-name="municipality-summary-title">Панель управления отраслью спорта: {result.name}</title>
                    <meta
                        name="apple-mobile-web-app-title"
                        content={`Панель управления отраслью спорта: ${result.name}`}
                    />
                    <meta
                        name="application-name"
                        content={`Панель управления отраслью спорта: ${result.name}`}
                    />
                </Helmet>
                <Heading size={"h1"} name="municipality-summary-main-header">Панель управления отраслью спорта: {result.name}</Heading>
                <MunicipalitySummaryView
                    currentDate={result.currentDate}
                    previousWeekStartDate={result.previousWeekStartDate}
                    previousWeekEndDate={result.previousWeekEndDate}
                    currentWeekStartDate={result.currentWeekStartDate}
                    currentWeekEndDate={result.currentWeekEndDate}
                    municipalitySummaryData={result.summary}
                    municipalityId={result.municipalityId}
                    municipalityRatingModel={result.municipalityRatingModel}
                    municipalityStatsModel={result.municipalityStatsModel}
                />
            </>
        );
    }
}
